import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaDownload,
} from 'react-icons/fa';
import profile from '../data/profile';
import Reveal from './Reveal';

const About = () => {
  const { t, i18n } = useTranslation();
  const country = profile.country[i18n.language] || profile.country.en;

  return (
    <section id="about" className="section about-section">
      <div className="container">
        <Reveal className="section-head">
          <span className="section-kicker">01 / {t('about.title')}</span>
          <h2 className="section-title">
            {t('about.title')}<span className="accent">.</span>
          </h2>
        </Reveal>

        <div className="about-grid">
          <Reveal className="about-photo" y={20} duration={800}>
            <div className="photo-stack">
              <span className="photo-orb photo-orb--1" aria-hidden="true" />
              <span className="photo-orb photo-orb--2" aria-hidden="true" />

              <div className="photo-card">
                <div className="photo-card-bar" aria-hidden="true">
                  <span /><span /><span />
                </div>
                <div className="photo-frame">
                  <img
                    src={`images/${profile.image}`}
                    alt={profile.name}
                    className="photo-img"
                  />
                </div>
                <div className="photo-card-meta">
                  <div>
                    <div className="photo-name">{t('hero.firstName')} {t('hero.lastName')}</div>
                    <div className="photo-role">
                      Mobile Frontend Developer
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          <div className="about-text">
            <Reveal delay={100}>
              <p className="about-bio">{t('about.bio')}</p>
            </Reveal>

            <Reveal delay={200} className="about-info">
              <h3>{t('about.contactDetails')}</h3>
              <ul className="info-list">
                <li>
                  <FaMapMarkerAlt />
                  <div>
                    <span className="info-label">{t('about.location')}</span>
                    <span className="info-value">{country}</span>
                  </div>
                </li>
                <li>
                  <FaEnvelope />
                  <div>
                    <span className="info-label">{t('about.email')}</span>
                    <a href={`mailto:${profile.email}`} className="info-value clickable">
                      {profile.email}
                    </a>
                  </div>
                </li>
                {/* <li>
                  <FaPhone />
                  <div>
                    <span className="info-label">{t('about.phone')}</span>
                    <a href={`tel:${profile.phone}`} className="info-value clickable">
                      {profile.phone}
                    </a>
                  </div>
                </li> */}
                {/* <li className="info-cta-cell">
                  <a
                    href={profile.resumeDownload}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary clickable"
                  >
                    <FaDownload /> {t('about.downloadResume')}
                  </a>
                </li> */}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
